import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Switch, Route } from 'react-router-dom';

import Router from '@magoosh/lib/router';
import ScrollToTop from '@magoosh/lib/scroll_to_top';

import { ModalProvider } from '@magoosh/context/modal_context';

import GoogleAnalyticsPageview from './components/google_analytics_pageview';

import { SchoolsAppProvider } from './context';
import routes from './routes';

interface Props {
  apiHost: string;
  initialData?: any;
  url: string;
}

const queryClient = new QueryClient();

const App: React.FC<Props> = (props) => {  
  if (props.initialData) {
    Object.keys(props.initialData).forEach((key) => {
      if (key === 'category' && props.initialData[key]) {
        const category = props.initialData[key];
        queryClient.setQueryData(['categories', category.slug], category)
      } else if (key === 'metric' && props.initialData[key]) {
        const category = props.initialData['category'];
        const metric = props.initialData[key];
        queryClient.setQueryData(['metrics', category?.slug, metric.slug], metric);
      } else if (key === 'profile') {
        const category = props.initialData['category'];
        const profile = props.initialData[key];
        queryClient.setQueryData(['profiles', category?.slug, profile.slug], profile);

        // If this is the default category, cache again with no category indicated
        if (category?.slug === profile.defaultCategorySlug) {
          queryClient.setQueryData(['profiles', undefined, profile.slug], profile);
        }
      } else {
        queryClient.setQueryData(key, props.initialData[key])
      }
    })
  }

  return (
    <QueryClientProvider client={queryClient}>
      <SchoolsAppProvider initialData={{ apiHost: props.apiHost }}>
        <Router location={props.url}>
          <ModalProvider>
            <GoogleAnalyticsPageview />
            <ScrollToTop />

            <Switch>
              {
                routes.map((route, idx) => {
                  return <Route {...route} key={idx} />
                })
              }
            </Switch>
          </ModalProvider>
        </Router>
      </SchoolsAppProvider>
    </QueryClientProvider>
  );
}

export default App;
